module.exports = __webpack_public_path__ + "static/img/29.9117e4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/29.png
// module id = tvVx
// module chunks = 0